import l from '../lang';

export default {
	'routes': {
		'index': 'voicemail.index',
	},
	'delete-single': l.t('voicemails.delete-single', 'Are you sure you want to delete this voicemail?'),
	'delete-filtered': l.t('voicemails.delete-filtered', 'Are you sure you want to delete all filtered voicemails?'),
	'delete-all': l.t('voicemails.delete-all', 'Are you sure you want to delete all voicemails?'),
	'successfull-creation': l.t('voicemails.successfully-created', 'Your voicemail has been added'),
	'successfull-update': l.t('app.successful-update', 'Your changes have been saved'),
	'failed-creation': l.t('voicemails.failed-creation', 'There was a problem creating your voicemail'),
	'failed-update': l.t('app.update-error', 'An error occurred while attempting to save your changes. Please try again.'),
};
